import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from "react-toastify"
import {useDispatch} from 'react-redux'

export const setLoginToken = createAsyncThunk(
    'loginModal/setLoginToken',
    async () => {
        const data = {}
        const response = await axios.post(`${process.env.REACT_APP_AUTH_URL}/setLoginToken.php`,
            data,
            {withCredentials: true}
        ).catch(() => {
            toast('Error Occurred!')
        })
        return response
    }
)

export const formSubmitAction = createAsyncThunk(
    'loginModal/formSubmitAction',
    async ({getState}) => {
        const state = getState()
        const dispatch = useDispatch()
        const {userVal, recaptchaValue} = state
        let data = new FormData()
        data.append("reqType", "Forgot")
        data.append("user", userVal)
        data.append("g-recaptcha-response", recaptchaValue)
        axios.post
        (
            `${process.env.REACT_APP_AUTH_URL}/auth.php`,
            data,
            {
                withCredentials: true
            }
        ).then(response => {
            const result = response.data.extra || ""
            const classes = (result.match(/class="(.*?)"/i) || [""])[1].split(' ')
            if (classes.indexOf('alert-danger') === -1) {
                dispatch(setResponseType({value: "info"}))
            } else {
                dispatch(setResponseType({value: "error"}))
            }
            dispatch(setResponsemsg({value: result}))

        }).catch(error => {
                toast('Error Occurred!')
            })
    }
)

const defaulState = {
    userVal: "",
    userError: false,
    responsemsg: "",
    responsetype: "error",
    recaptchaError: false,
    recaptchaValue: '',
    loading: false,
    recpatchSiteKey: "6LexF0sUAAAAADiQjz9BMiSrqplrItl-tWYDSfWa",
    userData:null,
    rememberMe:true,
    theme: "light",
}

const LoginModalSlice = createSlice({
    name: 'loginModal',
    initialState: {...defaulState},
    reducers: {
        setResponseType(state, action) {
            state.responsetype = action.payload.value
        },
        setRecaptchaValue(state, action) {
            state.recaptchaValue = action.payload.value
        },
        setUserError(state, action) {
            state.userError = action.payload.value
        },
        setResponsemsg(state, action) {
            state.responsemsg = action.payload.value
        },
        setUserVal(state, action) {
            state.userVal = action.payload.value
        },
        setLoading(state, action) {
            state.loading = action.payload.value
        },
        setRecaptchaErrorValue(state,action) {
            state.recaptchaError = action.payload
        },
        setUserData(state, action) {
            state.userData = action.payload
        },
        setRememberMe(state, action) {
            state.rememberMe = action.payload.value
        },
        clearStore(state) {
            Object.keys(defaulState).map(key=>{
                state[key] = defaulState[key]
            })
        },
        setTheme(state, action) {
            state.theme = action.payload;
        },
        extraReducers: {
            [setLoginToken.pending]: (state, action) => {
                state.userVal = ""
                state.userError = false
                console.log("Pendingggg !!!!")
            },
            [setLoginToken.fulfilled]: (state, action) => {
                console.log({
                    state,
                    action
                })
                state.userVal = "Some Value"
                state.userError = false
            },
            [setLoginToken.rejected]: (state, action) => {

            },
            [formSubmitAction.pending]: (state, action) => {

            },
            [formSubmitAction.fulfilled]: (state, action) => {

            },
            [formSubmitAction.rejected]: (state, action) => {

            }
        }
    }
})
export const {
    setLoading,
    setResponseType,
    setRecaptchaValue,
    setUserError,
    setUserVal,
    setResponsemsg,
    setRecaptchaErrorValue,
    clearStore,
    setUserData,
    setRememberMe,
    setTheme
} = LoginModalSlice.actions
export default LoginModalSlice.reducer